import { useQuery } from "@tanstack/react-query";
import PropTypes from "prop-types";
// Components
import RoundedBox from "@/Layouts/components/Basics/RoundedBox";
import EmptyBody from "@/Layouts/components/Basics/EmptyBody";
import UpdatedOn from "@/Washouts/components/UpdatedOn";

// Images
import empty from "@/assets/images/commons/empty.png";
import emptyTable from "@/assets/images/commons/empty_table.png";
// Hooks
import { useFactoryWashout } from "@/Washouts/hooks/useFactoryWashout";
import { useSingularPosition } from "@/Common/hooks/Positions";
import RenderWashoutInformation from "@/Washouts/components/RenderWashoutInformation";
import useApproveRetractWashoutSubscription from "@/Washouts/hooks/WashoutReview/useApproveRetractWashoutSubscription";
import useApproveAllWashoutSubscription from "@/Washouts/hooks/common/useApproveAllWashoutSubscription";

export default function MyWashoutContainer(props) {
	const {
		selected = null,
		location = null,
		user = {
			_id: "",
			position: "",
		},
	} = props;

	const positionToUse = useSingularPosition(selected?.position);
	const positionType = selected?.isDepartmental ? "Departmental" : "Producer";

	// Washout queries
	const { useWashoutQueries } = useFactoryWashout();
	const washoutQueries = useWashoutQueries(user?.position);

	const { data: model, isLoading } = useQuery({
		queryKey: ["getWashout", selected?.payPeriodId, selected?.position, user?._id, selected?.commissionCycleId],
		queryFn: async () => {
			const { locationId } = location || {};
			const { userId, commissionCycleId, payPeriodId, position } = selected || {};
			return washoutQueries?.getWashout(locationId, userId, commissionCycleId, payPeriodId, position);
		},
		enabled: !!location?.locationId && !!selected && !!user?._id,
		staleTime: Infinity,
	});

	useApproveRetractWashoutSubscription({
		locationId: location?.locationId,
		commissionCycleId: selected?.commissionCycleId,
		payPeriodId: selected?.payPeriodId,
		updateWashoutModel: true,
	});

	useApproveAllWashoutSubscription({
		locationId: location?.locationId,
		commissionCycleId: selected?.commissionCycleId,
		payPeriodId: selected?.payPeriodId,
	});

	return (
		<>
			<RenderWashoutInformation
				position={positionToUse}
				positionType={positionType}
				properties={{
					model,
					isLoading,
					locationId: location?.locationId,
				}}
			/>

			{!model && !isLoading && (
				<RoundedBox>
					<EmptyBody
						image={selected ? emptyTable : empty}
						title={selected ? "No washout found for this employee" : "Select an employee to view their washout"}
						bodyHeight={"510px"}
						sx={{
							boxShadow: "none !important",
						}}
					/>
				</RoundedBox>
			)}

			<UpdatedOn isLoading={isLoading} updatedOn={model?.created} />
		</>
	);
}
MyWashoutContainer.propTypes = {
	selected: PropTypes.object,
	location: PropTypes.object,
	user: PropTypes.object,
};
